import * as React from 'react'

import Top from 'src/components/molecules/Modal/QuestionnaireRequest/Top'
import Result from 'src/components/molecules/Modal/QuestionnaireRequest/Result'

interface IProps {
  children?: React.ReactNode
  options?: {
    use?: string
    resultID?: string
    callback?: Function
  }
}

const Component: React.FC<IProps> = (props) => {
  return (
    <>
      { props?.options?.use === 'top' && (
        <Top options={props.options} />
      )}
      { props?.options?.use === 'result' && (
        <Result options={props.options} />
      )}
    </>
  )
}
export default Component
